import React, { useState } from 'react';
import Aside from './Aside';
import Main from './Main';

function Layout({ setLocale }) {
  const [rtl] = useState(false);
  const [collapsed] = useState(false);
  const [image] = useState(true);
  const [toggled, setToggled] = useState(false);

  // const handleCollapsedChange = (checked) => {
  //   setCollapsed(checked);
  // };

  // const handleRtlChange = (checked) => {
  //   setRtl(checked);
  //   setLocale(checked ? 'ar' : 'en');
  // };
  // const handleImageChange = (checked) => {
  //   setImage(checked);
  // };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (

    <>
      <div className={`app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>


        <Aside
          image={image}
          collapsed={collapsed}
          rtl={rtl}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar}
        />

        <Main
          // image={image}
          // toggled={toggled}
          // collapsed={collapsed}
          // rtl={rtl}
          handleToggleSidebar={handleToggleSidebar}
        // handleCollapsedChange={handleCollapsedChange}
        // handleRtlChange={handleRtlChange}
        // handleImageChange={handleImageChange}
        />

      </div>


    </>
  );
}

export default Layout;